import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getAvailableRoles} from 'src/openapi/admin/apis/UserRoleApi';
import {useAppDispatch} from 'src/store';

import type {Role} from 'src/openapi/admin/models/Role';

type Return = {availableRoles: Role[], loading: boolean};

export const useAvailableRoles = (): Return => {
    const dispatch = useAppDispatch();

    const getDispatchAction = useCallback((signal: AbortSignal) => {
        return dispatch(getAvailableRoles({signal}));
    }, [dispatch]);

    const {data: availableRoles, isLoading: loading} = useReadOnlyDataHook({
        initValue: [] as Role[],
        getDispatchAction,
        shouldLoadData: true,
    });
    return {availableRoles, loading};
};
